import React, {ReactNode} from 'react';
import cn from 'classnames';

import {isTranslate} from 'shared/lib/lang';

import styles from './NotifyChannels.module.scss';

interface INotifyChannelIntroProps {
    text: ReactNode,
    children?: ReactNode,
}

const NotifyChannelIntro: React.FC<INotifyChannelIntroProps> = ({text, children}) => (
    <div className={cn(styles.textBlock, styles[isTranslate() ? 'enColor' : 'ruColor'])}>
        <span className={styles.text}>{text}</span>
        {children}
    </div>
);

export default NotifyChannelIntro;
